module.exports = __webpack_public_path__ + "img/telefono.b75f0932.svg";